var isNil = require('./type/is-nil');

function toString(value) {
  if (isNil(value)) return '';
  return value.toString();
}

module.exports = toString;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/to-string.js
// module id = 26
// module chunks = 0 1 2